import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        trainingForm: '=',
        form: '=',
        isDisabled: '=',
        key: '=',
        loading: '=',
        context: '='
    },
    template: `
    <ul class="tabs01">
        <li ng-repeat="lang in vm.getSortedLanguages()">
            <a
                ng-repeat="scormTraining in vm.trainingForm.scormTrainings"
                ng-class="{ active: vm.activeLang==scormTraining.lang, enabled: scormTraining.isEnabled==true }"
                ng-if="scormTraining.lang === lang"
                ng-click="vm.changeLang(scormTraining.lang)"
            >
                {{ scormTraining.lang }}
            </a>
        </li>
    </ul>
    <div ng-repeat="(index, scormTraining) in vm.trainingForm.scormTrainings">
        <form-row error="vm.form.errors.courseTrainings[vm.key].scormTrainings[index].file
            || vm.form.errors.courseTrainings[vm.key].scormTrainings[index].scormChunkId
            || vm.form.errors.courseTrainings[vm.key].scormTrainings[index]">
            <form-row-error></form-row-error>
        </form-row>
    </div>
    <div ng-repeat="(index, scormTraining) in vm.trainingForm.scormTrainings">
        <div ng-if="scormTraining.lang===vm.activeLang">
            <label class="switch02 mt2em visible-label">
                <input
                    ng-disabled="(vm.isDisabled && scormTraining.isEnabled && scormTraining.scorm.id && scormTraining.isInitiallyEnabled)"
                    type="checkbox"
                    ng-model="scormTraining.isEnabled"
                >
                <span class="ng-binding">{{ 'course.materialSource.Language enabled' | translate }}</span>
            </label>

            <ul
                class="actions01" ng-if="vm.trainingForm.materialType===vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM">
                <li class="fileupload">
                    <input id="uploadFile" ngf-select="vm.uploadScormFile($file, scormTraining)" type="file" />
                    <a class="btn bordered02 small">{{ 'training.Upload SCORM or xApi ZIP file' | translate }}</a>
                </li>
                <li><a class="btn bordered02 small" ng-click="vm.addUpload(scormTraining)">{{ 'training.Use existing file' | translate }}</a></li>
            </ul>

            <div class="row row-wide" error="vm.form.errors.courseTrainings[vm.key].scormTrainings[index].file || vm.form.errors.courseTrainings[vm.key].scormTrainings[index].scormChunkId">
                <span class="label w100p">{{ 'training.Uploaded file' | translate }}</span>
                <div class="items w100p">
                    <span class="text">{{ scormTraining.scormFileName }}</span>
                </div>
            </div>

        </div>
    </div>
    `
})
export default class {
    constructor (COURSE_TRAINING_MATERIAL_TYPE_ENUM, ScormSubmissionResource, ModalService, $translate, $state, $scope, $sce, $window,
        TokenService, lodash, ResponseService, $rootScope, UploadProgressService, ChunkUploadService) {
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.$rootScope = $rootScope;
        this.UploadProgressService = UploadProgressService;
        this.ChunkUploadService = ChunkUploadService;
        this.ScormSubmissionResource = ScormSubmissionResource;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.$sce = $sce;
        this.$scope = $scope;
        this.$state = $state;
        this.TokenService = TokenService;
        this.$window = $window;
        this.lodash = lodash;
        this.ResponseService = ResponseService;

        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        this.companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        this.activeLangLocalStorageKey = `scorm.activeLang.${this.form.model.courseId}${this.form.model.name}.${this.key}`;

        const activeLang = localStorage.getItem(this.activeLangLocalStorageKey);
        this.activeLang = activeLang === null ? this.defaultLanguage : activeLang;

        $scope.$watch('vm.activeLang', (newValue) => {
            $rootScope.$broadcast('versionActions:setSelectedScormTrainingIndex', {
                selectedScormTrainingIndex: this.trainingForm.scormTrainings.findIndex(item => item.lang === newValue)
            });
        });
        $scope.$on('scormContent:preview', () => {
            const scormTraining = this.trainingForm.scormTrainings.find(item => item.lang === this.activeLang);
            this.generateSubmission(scormTraining);
        });
    }

    $onInit () {
        if (!this.trainingForm.id) {
            this.trainingForm.scormTrainings = [];
        }
        this.lodash.forEach(this.companySupportedLanguages, lang => {
            const scormTraining = this.trainingForm.scormTrainings.find(item => item.lang === lang);
            if (!scormTraining) {
                let isEnabled = false;
                if (lang === this.defaultLanguage && this.context === 'add') {
                    isEnabled = true;
                }
                this.trainingForm.scormTrainings.push(
                    {
                        lang,
                        isEnabled,
                        isInitiallyEnabled: isEnabled // initial status. Is needed for buttons disabling logic
                    }
                );
            }
            else {
                if (scormTraining.scorm) {
                    scormTraining.scormFileName = scormTraining.scorm.name;
                    if (scormTraining.isInitiallyEnabled === undefined) {
                        scormTraining.isInitiallyEnabled = scormTraining.isEnabled;
                    }
                }
            }
        });
    }

    changeLang (lang) {
        this.activeLang = lang;
        localStorage.setItem(this.activeLangLocalStorageKey, lang);
    }

    getSortedLanguages () {
        const languages = [];
        languages.push(this.defaultLanguage);
        this.lodash.forEach(this.companySupportedLanguages, lang => {
            if (lang !== this.defaultLanguage) {
                languages.push(lang);
            }
        });

        return languages;
    }

    generateSubmission (scormTraining) {
        this.ScormSubmissionResource.save({
            name: 'Test submission name',
            email: 'example@opus.ee',
            scormTrainingId: scormTraining.id,
            userId: this.TokenService.getUser().id
        }).$promise.then((data) => {
            this.viewScorm(data.guid);
        });
    }

    viewScorm (guid) {
        const { $window, $state } = this;
        const params = {
            guid,
            viewOnly: 1
        };
        $window.open($state.href('scorm.do', params), '_blank');
    }

    addUpload (scormTraining) {
        const { form, trainingForm } = this;
        return this.ModalService.open({
            size: 'xlarge',
            template: `
                <modals-courses-version-training-scorm-files
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    planning-group="vm.planningGroup"
                    training-form="vm.trainingForm"
                    course-id="vm.form.model.courseId"
                    scorm-training="vm.scormTraining"
                />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.form = form;
                this.scormTraining = scormTraining;
                this.trainingForm = trainingForm;
                this.close = () => {
                    this.$scope.$apply();
                };
            }
        });
    }

    uploadScormFile ($file, scormTraining) {
        scormTraining.scormFileName = null;
        if (!$file) {
            return;
        }
        const hash = Date.now();

        scormTraining.scormFileName = $file.name;
        scormTraining.scormChunkId = hash;
        this.setLoading(true);

        const upload = this.UploadProgressService.start($file.name, $file.size);

        this.ChunkUploadService.upload(
            $file,
            `${SEED_CORE.ENV.API_URL}user/user/upload-chunk`,
            hash,
            loaded => this.UploadProgressService.setLoaded(upload, loaded)
        )
            .then(() => {
                scormTraining.isEnabled = true;
                scormTraining.scormId = null;
                this.setLoading(false);
                this.form.errors = false;
                this.UploadProgressService.succeed(upload);
            })
            .catch((response) => {
                this.setLoading(false);
                this.form.errors = this.ResponseService.parseErrors({ response });
                this.UploadProgressService.fail(upload, this.ChunkUploadService.getErrorMessage(response));
                scormTraining.scormChunkId = scormTraining.scormFileName = null;
            });
    }

    /**
     * The version actions sit in their own component, so the save button is told
     * to wait through the event it already listens to. Saving while the archive
     * is still on its way stores a training pointing at an incomplete upload.
     */
    setLoading (loading) {
        this.loading = loading;
        this.$rootScope.$broadcast('courseVersion:loading', { loading });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/scorm/content/index.js